import angular from 'angular';

export const componentsModule = angular.module(
  'portainer.edge.react.components',
  []
).name;
